import React, { useState ,useEffect} from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import InvoiceListLayer from "../components/InvoiceListLayer";
import { Link, useParams } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { API_URL } from "..";




const InvoiceStatusPage = () => {
    const {status} = useParams();

  const [data, setData]=useState([])

  const fetchInvoices =  async()=>{
      const user = JSON.parse(localStorage.getItem('user'));

      if(!user){
        window.location.href='/sign-in'
      }else{
        let body = JSON.stringify({
            affiliate_id: user.id,
            status : status
        })
        let headersList = {
          "Accept": "*/*",
          "Content-Type": "application/json"
         }
        if(status === 'all'){
            let response = await fetch( `${API_URL}/api/invoice/${user.id}`, { 
             method: "GET",
             headers: headersList
           });
           const data = await response.json();
           
           setData(data.invoices)

        }else{
            let response = await fetch( `${API_URL}/api/invoice/by-status`, { 
             method: "POST",
             body : body,
             headers: headersList
           });
           const data = await response.json();
           
           setData(data.invoices)

        }
       
      }
      
  }
  useEffect(()=>{
    fetchInvoices();
  },[1])
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Invoice" />
        
        {
          data.length== 0 ? null :
          <InvoiceListLayer jobsData={data}/>
        }

      </MasterLayout>

    </>
  );
};

export default InvoiceStatusPage;
